(function () {
  'use strict';

  angular
    .module('web2print.whereTo')
    .controller('WhereToController', WhereToController);

  WhereToController.$inject = ['$log', '$scope', '$rootScope', '$localStorage', '$state', '$stateParams', 'Common',
    'CountrySelectionFactory', 'whereToFactory', '$location', 'sidebarMyOrderFactory',
    'distributionFactory', 'Translation', 'productsFactory', '$timeout'];

  /* @ngInject */
  function WhereToController ($log, $scope, $rootScope, $localStorage, $state, $stateParams, Common,
    CountrySelectionFactory, whereToFactory, $location, sidebarMyOrderFactory,
    distributionFactory, Translation, productsFactory, $timeout) {

    let calculatePriceTimeOut;
    const vm = this;

    vm.isEditingParcel = false;

    vm.next = next;
    vm.loadCountries = loadCountries;
    vm.goBack = goBack;
    vm.getPriceForParcel = Common.getPriceForParcel;
    vm.getVatPriceForParcel = Common.getVatPriceForParcel;
    vm.setDirtyPreview = setDirtyPreview;
    vm.showZoneCount = false;
    vm.notODR = true;

    $scope.$on('changeLanguage', function (events, language) {
      console.log('Changing language');
      vm.language = language;
      moment.locale(language);
    });

    Common.registerObserver('web2print.products', updateProducts);
    checkSession();

    function checkSession () {
      const action = {
        0: angular.noop,
        1: Common.resetOrderData
      };

      const recipientsData = {
        'ADR': checkADRRecipients(),
        'ODR': Common.get('recipients.refinedAddressCount', 0),
        'FILE': Common.get('recipients.validAddressCount', 0)
      };

      if (Common.get('paymentStatus', false) === 'SUCCESS' || (!recipientsData[Common.get('recipients.addressType')] &&
        !sidebarMyOrderFactory.addressProcessing &&
        !Common.get('productDelivery', false))) {
        action[Number(Common.get('orderId', null) !== null)]();
        $location.path('/');
        return;
      }

      if (Common.get('productDelivery')) {
        vm.dateModel = moment(Common.get('productDelivery').deliveryDate);
      }

      vm.selectedDeliveryType = (Common.get('productDelivery', {}).pricingInfo || {}).deliveryOptions || null;
      vm.preface = Common.get('preface', false);
      vm.fetchingProducts = true;

      activate();
    }

    function checkADRRecipients () {
      // FILE option selected, skip the rest of the check
      const addressType = Common.get('recipients.addressType', 'FILE');
      const targetType = Common.get('recipients.targetType', 'INDIVIDUALS');
      const chipsRecipientsVal = {
        INDIVIDUALS: Common.get('recipients.refinedAddressCount', 0),
        COMPANIES: Common.get('recipients.refinedAddressCount', 0),
        FILE: Common.get('recipients.validAddressCount', 0)
      };

      const valid = chipsRecipientsVal[targetType] >= 100;
      vm.addresstype = addressType;
      vm.targettype = targetType;

      return valid;
    }

    // this is to render html tags
    function getTranslation (key) {
      return Translation.translate(key).value;
    }

    function activate () {
      $log.log('WhereToController : activate');

      if ($localStorage.editParcel) {
        vm.selectedType = angular.copy($localStorage.editParcel);
        vm.editParcel = angular.copy($localStorage.editParcel);
        vm.isEditingParcel = true;
        vm.editingFromState = $localStorage.editingFromState;
      } else if ($localStorage.selected) {
        vm.selectedType = $localStorage.selected;
      } else if ($localStorage.preferred) {
        vm.selectedType = _.omit($localStorage.preferred, 'itemId', 'cartId', 'isEditing', 'receiver', 'sender');
      }

      vm.sessionPath = 'material.deliveryType';
      vm.page = 'where-to';

      vm.products = [];
      vm.showZoneCount = Common.checkZoneCount();
      vm.getDeliveryDay = getDeliveryDay;
      vm.addresstype = Common.get('recipients.addressType');
      vm.targettype = Common.get('recipients.targetType');
      vm.getTranslation = getTranslation;
      vm.selectProductOption = selectProductOption;

      vm.fetchingProducts = true;
      const productDelivery = Common.get('productDelivery');
      const deliveryDate = productDelivery ? productDelivery.deliveryDate : undefined;
      Common.notifyObserver('web2print.products', { deliveryDate });
    }

    function updateProducts ({ deliveryDate, callback }) {
      productsFactory.fetchProducts(true, () => {
        vm.fetchingProducts = false;
        vm.products = productsFactory.products;
        getSelectedProduct();
        if (callback) {
          callback();
        }
      }, deliveryDate);
    }

    function getSelectedProduct () {
      const productDelivery = Common.get('productDelivery');
      if (productDelivery) {
        vm.products.forEach(function (product) {
          if (product.productId === productDelivery.productId) { //products must not share ids
            vm.selectedProduct = product;
          }
        });
      } else if (vm.products && vm.products.length) {
        vm.selectedProduct = vm.products[0];
      }

      distributionFactory.selectedProduct = vm.selectedProduct;
    }

    function loadCountries (language) {
      CountrySelectionFactory.getCountries(language).then(function (countries) {
        console.log('WhereToController : activate : countries');
        vm.countrySelection = countries;
        vm.selectedCountry = _.find(countries, {
          countryCode: $localStorage.receiverCountryCode
        });
      });
    }

    function setDirtyPreview () {
      Common.set('pristine', false);
      updateStorage();
    }

    function selectProductOption (option) {
      if (vm.selectedProduct && vm.selectedProduct.productId === option.productId) {
        return;
      }

      vm.selectedType = angular.copy(option);
      vm.selectedProduct = option;

      distributionFactory.selectedProduct = vm.selectedProduct;

      updateStorage();

      // this yields and error. commenting this one while searching for a solution
      // TODO: trace root cause of the problem
      // Common.set( scope.sessionPath, angular.copy( option ) );
      // Common.notifyObserver( scope.sessionPath );
    }

    function updateStorage () {
      whereToFactory.storeSelection(
        vm.selectedProduct,
        distributionFactory.selectedDate,
        angular.copy(distributionFactory.selectedDelivery),
        vm.preface,
        distributionFactory.deliveryDay
      );

      $timeout.cancel(calculatePriceTimeOut);
      calculatePriceTimeOut = $timeout(() => {
        Common.notifyObserver('web2print.pricing');
      }, 500);
    }


    function next () {
      updateStorage();
      $state.go('main.message');
    }

    function goBack () {
      $state.go('main.recipients');
    }

    function getDeliveryDay () {
      return distributionFactory.deliveryDay;
    }
  }
})();
